<template>
  <div class="text-center">
    <v-menu
      v-model="menu"
      offset-y
      transition="scale-transition"
      :close-on-content-click="true"
      :nudge-width="200"
    >
      <!-- Avatar Activator -->
      <template v-slot:activator="{ on, attrs }">
        <v-btn data-cy="menuUserBtn" icon v-bind="attrs" v-on="on">
          <v-avatar size="38">
            <v-img
              v-if="currentUser.imageURL"
              :src="currentUser.imageURL"
              alt="User"
            />
            <v-img v-else src="@/assets/images/user.jpeg" alt="User" />
          </v-avatar>
        </v-btn>
      </template>

      <!-- Menu Card -->
      <v-card elevation="2" class="rounded-lg">
        <v-list dense>
          <v-list-item>
            <v-list-item-content>
              <v-row no-gutters align="center">
                <v-col cols="auto">
                  <v-img
                    v-if="currentUser.imageURL"
                    :src="currentUser.imageURL"
                    class="menu-img"
                    alt="User"
                    contain
                  />
                  <v-img
                    v-else
                    src="@/assets/images/user.jpeg"
                    class="menu-img"
                    alt="User"
                    contain
                  />
                </v-col>

                <v-col class="ml-3">
                  <v-list-item-title class="font-weight-medium">
                    {{ currentUser.name }}
                  </v-list-item-title>
                  <v-list-item-subtitle>{{
                    currentUser.email
                  }}</v-list-item-subtitle>
                </v-col>
              </v-row>
            </v-list-item-content>

            <v-list-item-action>
              <v-btn
                data-cy="menuUserEditBtn"
                :to="`/settings/user/${currentUser.id}/edit`"
                color="pink"
                small
                icon
              >
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </v-list>

        <v-divider />

        <!-- Actions -->
        <v-card-actions class="px-4 py-2">
          <v-btn
            v-if="currentUser.organizationCount > 1"
            text
            color="primary"
            to="/login/organization"
          >
            {{ $t("labels.changeOrganization") }}
          </v-btn>

          <v-spacer></v-spacer>

          <v-btn color="primary" to="/logout"> Logout </v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "layout-menu",
  data() {
    return {
      menu: false,
    };
  },
  computed: {
    ...mapGetters("global", ["currentUser"]),
  },
};
</script>

<style scoped>
.menu-img {
  border-radius: 6px;
  width: 48px;
  height: 48px;
  object-fit: cover;
}
</style>